<template>
  <div class="contaier">
    <div class="max-box">
      <div class="contact-box">
        <div class="icon-box">
          <div class="icon">
            <a
              data-v-f6f9010e=""
              href="https://www.facebook.com/HongqiHK"
              target="_blank"
              title="HongQiHongKong on Facebook"
              class="iconfont_">
              <img
                src="./../assets/img/footer/facebook.png"
                loading="lazy"
                alt="" />
            </a>
          </div>
          <!-- <div class="icon">
            <img
              src="./../assets/img/footer/twitter.png"
              loading="lazy"
              alt="" />
          </div> -->
          <div class="icon">
            <a
              data-v-f6f9010e=""
              href="https://www.instagram.com/hongqi_hongkong/"
              target="_blank"
              title="HongQiHongKong on Instagram"
              class="iconfont_">
              <img
                src="./../assets/img/footer/footer_5.png"
                loading="lazy"
                alt="" />
            </a>
          </div>
        </div>

        <div class="nag-box">
          <div class="nag" @click="goNewPage1()">
            {{ $t('home.statement_') }}
          </div>
          <div class="nag" @click="goNewPage()">
            {{ $t('home.policy_') }}
          </div>
          <!-- <div class="nag" @click="goNewPage('/')">
            {{ $t('homeP.home') }}
          </div>
          <div class="nag" @click="goNewPage('/about')">
            {{ $t('homeP.about') }}
          </div>
          <div class="nag" @click="goNewPage('/contact')">
            {{ $t('homeP.contact') }}
          </div>-->
        </div>

        <!-- <div class="contact-title">CONTACT US:hq_iec@faw.com.cn</div> -->

        <!-- <div class="contact">
          Follow us and use following social media platforms to get in contact
          with us and to share your passion for the brand, products and services
          of Hongqi.
        </div> -->
      </div>
      <div class="sales-hotline">
        <a href="tel:2119-4889" class="sales"
          >{{ $t('home.salesHotline') }}2119-4889</a
        >
      </div>
      <div class="contact-title">
        Copyright ©2026 Kam Lung Motor Group. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterPage',
  methods: {
    goNewPage() {
      window.open('https://www.kamlung.com/privacy-policy?lang=tc', '_blank')
    },
    goNewPage1() {
      window.open(
        'https://www.kamlung.com/copy-of-privacy-policy?lang=tc',
        '_blank'
      )
    },
    // goNewPage(p) {
    //   this.$router
    //     .push({ path: p, query: { lang: this.$i18n.locale } })
    //     .catch(() => {})
    // },
  },
}
</script>
<style lang="scss" scoped>
.contaier {
  padding: 40px 20px 30px;
  background-color: #333;
  color: #999;
  .contact-title {
    font-size: 14px;
    // line-height: 4;
    // text-transform: uppercase;
    // font-weight: 700;
    border-top: solid 1px #666;
    margin-top: 30px;
    padding-top: 30px;
    letter-spacing: 0.1em;
    color: #898989;
  }
  .contact-box {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // max-width: 800px;
    .contact {
      color: #898989;
    }
    .icon-box {
      width: 100px;
      // padding-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .icon {
      width: 28px;
      margin: 0 20px 0 0;
      cursor: pointer;
      filter: grayscale(100%);
      transition: all 0.3s;
      cursor: pointer;
    }
    .icon:hover {
      filter: grayscale(0);
      transition: all 0.3s;
    }
    .nag-box {
      .nag {
        // padding: 0 15px;
        cursor: pointer;
        line-height: 60px;
      }
      .nag:nth-child(n + 2) {
        // padding-left: 20px;
      }
    }
  }
  .sales-hotline {
    font-size: 14px;
    padding-top: 20px;
  }
}

@media (max-width: 768px) {
  .contaier {
    .contact-box {
      .icon-box {
        padding-bottom: 20px;
      }
    }
  }
}
@media (min-width: 768px) {
  .contaier {
    padding: 40px 20px 30px;
    .contact-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nag-box {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .nag {
          // padding: 0 30px;
          // padding: 20px;
          line-height: 40px;
          font-size: 14px;
        }
        .nag:nth-child(n + 2) {
          padding-left: 20px;
        }
      }
    }
    .sales-hotline {
      font-size: 16px;
      padding-top: 30px;
    }
  }
}
</style>
